import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Surveys from 'features/surveys';

const Page = () => (
  <MainLayout>
    <Surveys />
  </MainLayout>
);

export default Page;
